import React from 'react';
import { connect } from 'react-redux';
import { maxBy, isEqual, find, omit } from 'lodash';
import ReactTable from "react-table";
import CSV from '../../../helpers/CSVExport';
import ReactSelect from '../../common/ReactSelect';

import config from '../../../config/config';
import Box from '../../common/Box';
var downloadSvg = require('!svg-inline-loader!../../../../public/img/download.svg');
import { statsActions } from '../../../data/actions/stats';
import { BarChart, LineChart, IncrementalLineChart } from '../../widgets/charts/types';
import { splitByThousands } from '../../../helpers/NumberFormatter';

class IncomeChart extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			chartMode: 'income',
			mode: 'discrete'
		}
		this.exportToCsv = this.exportToCsv.bind(this);     
		this.getTimeseriesData = this.getTimeseriesData.bind(this);
		this.setChartMode = this.setChartMode.bind(this);
		this.setMode = this.setMode.bind(this);
  
   
	}
	
	exportToCsv(){
		const { tracks, id }  = this.props,
			exportData = tracks.demographicsComparison[id].data;        
		const filename = CSV.CSVHeader(`track-comparison-demographics`, id);
		return CSV.CSVExport(exportData, {filename}, 'track-comparison-demographics');
	}

	renderToolbar(){
		const { mode, chartMode } = this.state;
		const chartModes = [
			{label: 'Income', value: 'income'},
			{label: 'Quantity', value: 'quantity'},
		];
		const currentChartMode = find(chartModes, m=>m.value == chartMode);
		
		const modes = [
			{label: 'Absolute', value: 'discrete'},
			{label: 'Accruing', value: 'cumulative'},
		];
		const currentMode = find(modes, m=>m.value == mode);


		let toolbar = [];
		toolbar.push(<div key="wrapper" className="ibox-action-holder">
		<div className="ibox-actions">
			Chart: <ReactSelect options={modes} value={currentMode} onChange={this.setMode} className="single-select" />
			Metric: <ReactSelect options={chartModes} value={currentChartMode} onChange={this.setChartMode} className="single-select" />
		  <a key="download" title="Export CSV" onClick={this.exportToCsv} className="chart-icon download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />
		</div>
		</div>)
		return toolbar;
	}

	setMode(mode){
		this.setState({mode: mode.value}, ()=>{
		});
	}
	
	setChartMode(mode){
		this.setState({chartMode: mode.value});
	}

	componentDidMount() {
		const { entities } = this.props;
		this.props.dispatch(statsActions.compareEntitiesIncome(entities))
		
	}
	
	componentWillReceiveProps(nextProps) {		
		if(nextProps.entities){
			if(this.props.entities!==undefined && !isEqual(nextProps.entities, this.props.entities)) {
				this.props.dispatch(statsActions.compareEntitiesIncome(nextProps.entities))
			}                
		}
		
		if(nextProps.filter && nextProps.filter.global){
			if(this.props.filter.global!==undefined){
				const hasChanged = !isEqual(
					omit(nextProps.filter.global, ['monthsSinceRelease']),
					omit(this.props.filter.global, ['monthsSinceRelease'])
					);
				
				if(hasChanged)
					this.props.dispatch(statsActions.compareEntitiesIncome(nextProps.entities));
					
			}
		}
	}
	
	getTimeseriesData(chartData){
		const { chartMode } = this.state;
		if(chartData && chartData.datasets) {
			for(let dataset of chartData.datasets)
				dataset['data'] = [...dataset[chartMode]];
		}
			
		return chartData;
	}
	
	render (){
		const { entitiesIncome: chartData, entitiesIncomeLoading } = this.props.stats;
		const { mode, metric } = this.state;
		const data = this.getTimeseriesData(chartData);
		const chartOptions = {
			scales: {
			   xAxes: [{
				   ticks : {
					   callback: function(value, index, values) {
						   return 'Month ' + value
					   },
				   }
			   }],
		   }
		}
		
		return <Box title="" spinnerEnabled={entitiesIncomeLoading} toolbar={this.renderToolbar()}>
		
			{chartData && <div className="row">
				<div className={`col-xs-12`}>
					{chartData.datasets.length > 0 && <div className="chart-block">
						{mode == 'discrete' && <LineChart data={data} id={'sales'} options={chartOptions} />}
						{mode == 'cumulative' && <IncrementalLineChart data={data} id={'sales'} options={chartOptions} />}
						
					</div>}
					{!chartData.datasets.length && <p>No data available</p>}
				</div>    
			</div>}
		</Box>
	}
}

function mapStateToProps(state) {
	return {
		stats: state.stats,
		filter: state.filter,
	} 
}

export default connect(mapStateToProps)(IncomeChart);